/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccessExpirationResponse
 */
export interface AccessExpirationResponse {
    /**
     * 
     * @type {any}
     * @memberof AccessExpirationResponse
     */
    id?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AccessExpirationResponse
     */
    value?: any | null;
}

/**
 * Check if a given object implements the AccessExpirationResponse interface.
 */
export function instanceOfAccessExpirationResponse(value: object): value is AccessExpirationResponse {
    return true;
}

export function AccessExpirationResponseFromJSON(json: any): AccessExpirationResponse {
    return AccessExpirationResponseFromJSONTyped(json, false);
}

export function AccessExpirationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessExpirationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : json['value'],
    };
}

export function AccessExpirationResponseToJSON(json: any): AccessExpirationResponse {
    return AccessExpirationResponseToJSONTyped(json, false);
}

export function AccessExpirationResponseToJSONTyped(value?: AccessExpirationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'value': value['value'],
    };
}

